import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { CacheService } from '../../services/cache/cache.service';
import { CommonService } from '../../services/common/common.service';
import { Column } from '../interfaces/column.interface';
import moment from 'moment';
import { RecipesDataService } from './recipes-data.service';
import { Recipe, RecipesResult } from '../interfaces';
// import { UsersDataService } from './users-data.service';
import { User, UsersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class StepsColumnsService {

  public recipes: Recipe[] = [];
  public users: User[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private cache: CacheService,
    private common: CommonService,
    private recipesDataService: RecipesDataService,

  ) {
    this.getRecipes()
    // this.getUsers()
  }

  getRecipes(offset: number = 0): void {
    const cacheKey: string = 'recipes.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.recipes = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.recipesDataService.getRecipes(parameters).subscribe((response: RecipesResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.recipes = response.results;
        } else {
          this.recipes = this.recipes.concat(response.results);
        }
        if (response.inlineCount > this.recipes.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getRecipes(offset);
        }
        response.results = this.recipes;
        this.cache.set(cacheKey, response);
      }
    });
  }

  // getUsers(offset: number = 0): void {
  //   const cacheKey: string = 'users.cache'
  //   const cache: any = this.cache.get(cacheKey);
  //   if (cache !== null && offset === 0) {
  //     this.users = cache.results
  //     return;
  //   }
  //   const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
  //   this.usersDataService.getUsers(parameters).subscribe((response: UsersResult|any) => {
  //     if (response !== null) {
  //       if (offset === 0) {
  //         this.users = response.results;
  //       } else {
  //         this.users = this.users.concat(response.results);
  //       }
  //       if (response.inlineCount > this.users.length) {
  //         offset = offset + parseInt(this.defaultParameters.limit + '', 10);
  //         this.getUsers(offset);
  //       }
  //       response.results = this.users;
  //       this.cache.set(cacheKey, response);
  //     }
  //   });
  // }

  getColumns(): Column[] {
    return [
      { field: 'id', sortField: 'id', title: this.translate.instant('ID'), show: (this.navigation.getParamValue('steps.id.showFiled', true) && true), displayInList: true, type: 'numericValue'},
      { field: 'description', sortField: 'description', title: this.translate.instant('DESCRIPTION'), show: (this.navigation.getParamValue('steps.description.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'descriptionAr', sortField: 'descriptionAr', title: this.translate.instant('DESCRIPTIONAR'), show: (this.navigation.getParamValue('steps.descriptionAr.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'descriptionFr', sortField: 'descriptionFr', title: this.translate.instant('DESCRIPTIONFR'), show: (this.navigation.getParamValue('steps.descriptionFr.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'title', sortField: 'title', title: this.translate.instant('CONTENT.TITLE'), show: (this.navigation.getParamValue('posts.title.showFiled', true) && true), displayInList: true, type: 'textValue' },
      { field: 'TitleEn', sortField: 'TitleEn', title: this.translate.instant('CONTENT.TitleEn'), show: (this.navigation.getParamValue('posts.TitleEn.showFiled', true) && true), displayInList: true, type: 'textValue' },
      { field: 'titleFr', sortField: 'titleFr', title: this.translate.instant('CONTENT.TITLEFR'), show: (this.navigation.getParamValue('posts.titleFr.showFiled', true) && true), displayInList: true, type: 'textValue' },
      { field: 'titleAr', sortField: 'titleAr', title: this.translate.instant('CONTENT.TITLEAR'), show: (this.navigation.getParamValue('posts.titleAr.showFiled', true) && true), displayInList: true, type: 'textValue' },

      { field: 'recipe', title: this.translate.instant('RECIPE'), type: 'linkValue', filterData: this.recipes, show: (this.navigation.getParamValue('steps.recipeId.showFiled', true) && true), displayInList: true, filterField: 'recipe.id', displayField: 'name', sortField: 'recipe.name', url: 'recipes' },
      { field: 'createdAt', sortField: 'createdAt', title: this.translate.instant('CREATEDAT'), show: (this.navigation.getParamValue('steps.createdAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'actions', title: this.translate.instant('CONTENT.ACTIONS'), type: 'static', show: true, displayInList: true, sortField: null},
    ];
  }

  format(fieldName: string, value: any) {
    if (fieldName.toLowerCase().indexOf('time') > -1) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else if (fieldName.toLowerCase().indexOf('date') > -1) {
      return moment(value).format('YYYY-MM-DD');
    }
    return value;
  }

}
